import * as React from 'react';
import {connect} from 'react-redux';

// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';

import type {SalesAutomationItemType} from '../../../../sales-automation/types';
import type {NutshellState} from '../../../../store';

import {getHoveredStageId} from '../../ui-selectors';

import {SalesAutomationNewCard} from '../cards/sales-automation-new-card';

import {CardsErrorState} from './cards-error-state';

import styles from './cards-container.module.css';

function mapStateToProps(state: NutshellState): StateProps {
    return {
        stageIdBeingHovered: getHoveredStageId(state),
    };
}

type OwnProps = {
    parentId: string;
    type: SalesAutomationItemType;
    item: React.ReactElement<any> | null | undefined; // React.Component,
    isLoading: boolean;
    hideAddCard: boolean;
    errorMessage: string | null | undefined;
};

type StateProps = {
    stageIdBeingHovered: string | null | undefined;
};

type Props = OwnProps & StateProps;

export class StageSingleItemContainerComponent extends React.PureComponent<Props> {
    render() {
        let containerChild = (
            <div className={styles['column-container']}>
                <SalesAutomationNewCard
                    parentId={this.props.parentId}
                    type={this.props.type}
                    isHidden={this.props.hideAddCard}
                />
            </div>
        );

        if (this.props.isLoading) {
            containerChild = (
                <div className={styles['loading-container']}>
                    <LoadingIcon size={28} />
                </div>
            );
        }

        // Error state
        if (this.props.errorMessage) {
            containerChild = <CardsErrorState errorMessage={this.props.errorMessage} />;
        }

        if (this.props.item) {
            containerChild = <div className={styles['column-container']}>{this.props.item}</div>;
        }

        // Default: Empty State
        return (
            <div
                className={
                    this.props.stageIdBeingHovered === this.props.parentId
                        ? styles['container--highlighted']
                        : styles.container
                }
            >
                {containerChild}
            </div>
        );
    }
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(mapStateToProps);
export const StageSingleItemContainer = connector(StageSingleItemContainerComponent);
